import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import es from 'vuetify/lib/locale/es';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
      options: {
        customProperties: true,
      },
    themes: {
      light: {
        primary: '#0d47a1', 
        secondary: '#1976d2',
        accent: '#1976d2',
        error: '#7f0000',
        info: '#0d47a1',
        success: '#4caf50',
        warning: '#ffeb3b',
      },
      dark: {
        primary: "#1976d2",
      },
    },
  },
    lang: {
      locales: { es },
      current: 'es',
    },
});

